module.exports = __webpack_public_path__ + "static/media/tj_bg.2de250b1.png";